<template>
  <div id="classroomComments">
    <!-- <a-form :model="queryParam" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" name="basic">
      <a-row justify="space-between">
        <a-col :span="4">
          <a-form-item label="考试名称名称">
            <a-input v-model="queryParam.username" placeholder="请输入练习名称" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="状态">
            <a-select ref="select" v-model="queryParam.value1" placeholder="请选择状态">
              <a-select-option value="jack">全部</a-select-option>
              <a-select-option value="jack">进行中</a-select-option>
              <a-select-option value="jack2">已结束</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="">
            <a-button type="primary" style="margin-left: 20px;">
              查询
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form> -->
    <div>
      <a-table class="j-table-force-nowrap" :scroll="{ x: true }" ref="table" bordered size="middle" rowKey="id"
        :columns="columns" :dataSource="paperDataSource" :pagination="pagination" :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a-button type="primary" :disabled="!record.isOpen" @click="toPaper(record)">
            <span>{{ $t('exam.toExam') }}</span>
            <a-icon type="right" />
          </a-button>
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
  import { getAction,deleteAction } from '@/api/manage'
export default {
  name: "practise",
  components: {},
  data() {
    return {
      paperDataSource: [],
      columns: [
        {
          title: '试卷库',
          align: "center",
          dataIndex: 'paperType_dictText',
          width: 120,
        },
        {
          title: '试卷名',
          align: "center",
          dataIndex: 'paperName',
          customRender(v, r) {
            return r.examName || r.paperName
          }
        },
        {
          title: '开放时间',
          align: "center",
          dataIndex: 'openMethod',
          width: 180,
          customRender(v, r) {
            if (v == 1) {
              return "长期有效"
            } else if (v == 2) {
              return r.startTime.split(" ")[0] + " - " + r.endTime.split(" ")[0]
            } else if (v == 3) {
              return '通过上一级别'
            }
          }
        },
        // {
        //     title:'来源',
        //     align:"center",
        //     dataIndex: 'paperType_dictText',
        //   },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        onChange: (page) => {
          this.pagination.current = page
        },
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: true,
      queryParam: {
        isSimulation: 0,
        paperType: undefined,
        userPaperStatus: '',
      },
      disableMixinCreated: true
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleChangeType(v) {
      this.queryParam.paperType = v
      this.getPaperList()
    },
    handleChangeStatus(v) {
      this.queryParam.userPaperStatus = v
      this.getPaperList()
    },
    getPaperList() {
      this.loading = true
      this.paperDataSource = []
      getAction('/teaching/teachingPaper/minePaperList', {
        isSimulation: this.queryParam.isSimulation,
        paperType: this.queryParam.paperType,
        userPaperStatus: this.queryParam.userPaperStatus,
        pageSize: 999,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          for (let i in res.result) {
            let p = res.result[i]
          }
          this.paperDataSource = res.result
          this.pagination.total = res.result.length
        }
        this.loading = false
      })
    },
    getUserPaperStatus(status) {
      console.log(status);
      if (status == null) {
        return ['gray', this.$t('exam.noAnswer')]
      }
      if (status == 0) {
        return ['orange', this.$t('exam.saved')]
      }
      if (status == 1) {
        return ['green', this.$t('exam.nosubmittedAnswer')]
      }
      if (status == 3) {
        return ['blue', this.$t('exam.Corrected')]
      }
      return ['gray', status]
    },
    toPaper(info) {
      let route = this.$router.resolve({
        path: '/examine',
        query: {
          id: info.paperId,
          departId: info.departId,
          paperId: info.paperId
        },
      });
      window.open(route.href, '_blank')
    },
    toMyPaperAnswer() {
      this.$router.push({
        name: 'myPaperAnswer'
      })
    }

  },
  created() { this.getPaperList() },
  mounted() { },
};
</script>
<style lang='scss' scoped>
//@import ''; 引入公共css类
#classroomComments {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 15px;
}
</style>